import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
export var HeaderBas = function () {
  var location = useLocation();
  var index = 'index,follow';
  var title = /*#__PURE__*/React.createElement("title", null, "\u25B7 Telefonsex mit kostenloser Livecam | BeiAnrufSex.com");
  var description = /*#__PURE__*/React.createElement("meta", {
    name: 'description',
    content: 'll▷ ☎ Spreche jetzt mit privaten Amateuren real am Telefon & sehe ihnen kostenlos per Livecam zu ☎ Telefonsex mit Cam ✅ mit Bild ✅ LIVE'
  });
  var canonical = /*#__PURE__*/React.createElement("link", {
    rel: 'canonical',
    href: window.location.origin + location.pathname
  });
  var isHome = location.pathname === '/';
  var isProfile = location.pathname.indexOf('/profil/') === 0;
  var isCategory = location.pathname.indexOf('/kategorie/') === 0;
  var isPhoneSex = location.pathname.indexOf('/telefonsex/') === 0;
  if (isHome || isCategory || isPhoneSex) {
    index = 'index,follow';
  } else if (isProfile) {
    // Only lovely girls get indexed
    var girl = location.pathname.replace('/profil/', '').replace('/', '');
    title = /*#__PURE__*/React.createElement("title", null, "\u25B7 Telefonsex mit ", girl, " in ihrer Livecam | BeiAnrufSex.com");
    description = /*#__PURE__*/React.createElement("meta", {
      name: 'description',
      content: "ll\u25B7 \u260E Spreche jetzt mit ".concat(girl, " real am Telefon & sehe ihr kostenlos per Livecam zu \u260E Telefonsex mit Cam \u2705 mit Bild \u2705 LIVE")
    });
  } else {
    // All other pages dont index
    index = 'noindex,follow';
  }
  // Noindexed pages should never have a canonical url?!
  if (index.indexOf('noindex') !== -1) {
    canonical = null;
  }
  return /*#__PURE__*/React.createElement(Helmet, null, title, description, /*#__PURE__*/React.createElement("meta", {
    name: 'robots',
    content: index
  }), canonical);
};